import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type DeletePositionDialogProps = {
  overlay: OverlayState
  positionName: string
  onDelete: () => void
}

export default function DeletePositionDialog({
  overlay,
  positionName,
  onDelete,
}: DeletePositionDialogProps) {
  return (
    <Dialog {...overlay} title={`Delete “${positionName}”?`}>
      <DialogContent>
        <Typography>
          You are about to delete this position. Note: a position can&apos;t be
          deleted while an approval policy is using it, or once someone has
          approved a document as its holder.
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onDelete()
            overlay.close()
          }}
        >
          Delete position
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
